import MemoriaMaratoComponent from './MemoriaMarato';
import MemoriaMaratoSubpagina from './MemoriaMaratoSubpagina';

export default function MemoriaMarato(props) {
    if (props.isSeccio) {
        return <MemoriaMaratoSubpagina {...props} />;
    }
    return <MemoriaMaratoComponent {...props} />;
}
